import React, { ReactElement, ReactNode } from 'react';

import { animated, useSpring } from 'react-spring';
import { useDrag } from 'react-use-gesture';

export interface SlideUpPanelContainerProps {
  children: ReactNode | ReactNode[];
  className?: string;
  closeable?: boolean;
  onClose: () => void;
  open: boolean;
}

const SlideUpPanelContainer = ({ children, closeable = false, onClose }: SlideUpPanelContainerProps): ReactElement => {
  let style;
  let handle;

  if (closeable) {
    const [{ y }, set] = useSpring(() => ({ y: 0 }));

    style = { transform: y.interpolate(y => `translate3d(0, ${y}px, 0)`) };

    const bind = useDrag(({ cancel, distance, down, movement: [, my] }) => {
      if (distance > window.innerHeight / 3) {
        cancel?.();
        onClose();
      }

      set({ y: (down && my > 0) ? my : 0 });
    });

    handle = <div className="c-slide-up-panel__handle" {...bind()} />;
  }

  return (
    <animated.div className="c-slide-up-panel__container" style={style}>
      {handle}

      {children}
    </animated.div>
  );
};

export default SlideUpPanelContainer;
